"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildSyncResolvedParams = void 0;
function BuildSyncResolvedParams(params) {
    return params;
}
exports.BuildSyncResolvedParams = BuildSyncResolvedParams;
